import { Button, Group, List, Modal, Stack, Text } from "@mantine/core";
import { type JSX, useEffect } from "react";

import { useAnalytics } from "@/analytics";
import { useLogger } from "@/sdk/logging/LoggerProvider";

import { useTroubleshootingStore } from "./troubleshoot.store";

export function Troubleshooting(): JSX.Element | null {
    const logger = useLogger({ module: "Troubleshooting" });
    const { setIsTroubleshooting } = useTroubleshootingStore();
    const { dispatcher } = useAnalytics();

    const handleCloseTroubleshooting = () => {
        setIsTroubleshooting(false);
    };

    useEffect(() => {
        logger.info("Troubleshooting | open");
        void dispatcher.dispatchBusinessEvent("TroubleshootingOpen");
    }, [dispatcher, logger]);

    const onClose = () => {
        void dispatcher.dispatchBusinessEvent("TroubleshootingClose");
        logger.info("Troubleshooting | close");
        setIsTroubleshooting(false);
    };

    return (
        <Modal
            opened
            centered
            onClose={onClose}
            withCloseButton={false}
            closeOnClickOutside={false}
            closeOnEscape={false}
        >
            <Stack>
                <Text size="lg" c="gray.3">
                    Call failed to connect-refresh EVL and check your audio settings
                </Text>
                <List mt="sm" size="sm" c="gray.6">
                    <List.Item>Go to EVL and refresh it (or load it if not already open)</List.Item>
                    <List.Item>Make sure EVL is fully connected</List.Item>
                    <List.Item>Go to Available</List.Item>
                </List>
                <Group justify="right">
                    <Button onClick={handleCloseTroubleshooting}>Ok</Button>
                </Group>
            </Stack>
        </Modal>
    );
}
